import React from 'react';

import classes from './style.module.scss';

export type ContentComponent = React.FC

const Content: ContentComponent = ({ children }) => <div className={classes['main-content']}>{children}</div>;

export default Content
